import { genericGet } from "../../../services/api.service";
import { EntityConfig } from "../../..";

export const FaturacaoFornecedoresTableConfigs : EntityConfig = [
    {
        id: 'id',
        label: 'Id',
        type: 'id',
        nonEditable: true
      },
    {
      id: 'code',
      label: 'Fatura',
      type: 'text',
      filterable: true
    },
    
    {
      id: 'supplier',
      label: 'Fornecedor',
      type: 'select',
      filterable: true,
      routable: true,
      options: {
        name: 'Fornecedor',
        route: 'fornecedores',
        value: 'id',
        label: 'name',
        getter: ()=>genericGet('/findByFilter/fornecedores'),
        searcheable: true
      }
    },
    {
      id: 'date',
      label: 'Data',
      type: 'date',
      filterable: true,
      separateValueUpdateOptions: {
        operation: async (obj: any, state : any)=> {  
          if(!obj['date'] || ! state['supplier'])
            return;
          const supplier = await genericGet(`/fornecedores/${state['supplier'].id}`)
          const date = new Date(obj['date'])
          date.setDate(date.getDate() + supplier.paymentTime);
          const result = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
          obj['dueDate'] = result;
        },
      }
    },

    {
        id: 'value',
        label: 'Valor',
        type: 'number',
        displayInfo: 'currency'
    },
    {
        id: 'dueDate',
        label: 'Data de Vencimento',
        type: 'date',
        filterable: true
    },
    {
        id: 'paymentDate',
        label: 'Data de Pagamento',
        type: 'date',
        filterable: true
      },
    {
      id: 'paid',
      label: 'Pago',
      type: 'boolean',
      filterable: true
    }
  ];
  